import React from 'react';
import PropTypes from 'prop-types';
import { JOYBIRD_MESSAGING_TERMS_LINK } from 'commons/constants';
import CtaLink from 'components/essentials/Cta/CtaLink';
import Checkbox from 'components/consumer/Checkbox';

const OptInSmsMarketing = ({
  checked,
  name = 'opt_in_sms_marketing',
  onClick,
}) => (
  <Checkbox
    name={name}
    checked={checked}
    onClick={() => {
      onClick(!checked);
    }}
    size="xs"
    className="mx-0 my-[1.2em]"
  >
    Receive email or text message (e.g., SMS, MMS, and RCS) updates from Joybird
    (including launch announcements, product info, and design inspiration). You
    can unsubscribe anytime. By signing up, you agree to our{` `}
    <CtaLink
      to="/privacy-policy/"
      color="brand"
      hasArrow={false}
      noLinkPadding
      size="xs"
      target="_blank"
    >
      Privacy Policy
    </CtaLink>
    {' | '}
    <CtaLink
      to={JOYBIRD_MESSAGING_TERMS_LINK}
      color="brand"
      hasArrow={false}
      noLinkPadding
      size="xs"
      target="_blank"
    >
      Terms of Use
    </CtaLink>
    .
  </Checkbox>
);

OptInSmsMarketing.propTypes = {
  checked: PropTypes.bool,
  name: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};

export default OptInSmsMarketing;
